import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    loading: false,
    user: null,
    authorization: '',
    chSubscriptions: [],
    channelType: 'articles',
    customToken: '',
    feedPopup: false,
  },
  mutations: {
    async initialiseStore(state) {
      const user = localStorage.getItem('user');
      if (user) {
        state.user = JSON.parse(user);
      }
      const token = localStorage.getItem('token');
      if (token) {
        state.authorization = token;
        axios.defaults.headers.common.Authorization = token;
      }
    },
    toggleLoading(state, payload) {
      state.loading = payload;
    },
    setSignedIn(state, payload) {
      state.user = payload.user;
      state.authorization = payload.token;
      axios.defaults.headers.common.Authorization = payload.token;
      localStorage.setItem('user', JSON.stringify(state.user));
      localStorage.setItem('token', payload.token);
    },
    setLogout(state) {
      state.user = null;
      state.authorization = '';
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      localStorage.removeItem('customToken');
    },
    updateChSubscriptions(state, payload) {
      state.chSubscriptions = payload;
    },
    updateChannelType(state, payload) {
      state.channelType = payload;
    },
    setCustomToken(state, payload) {
      state.customToken = payload;
    },
    removeCustomToken(state) {
      state.customToken = '';
    },
    updateFeedPopup(state, payload) {
      state.feedPopup = payload;
    },
  },
});

export default store;
